import { Search } from 'lucide-react';

import { Input } from './input';

export function SearchInput() {
  return (
    <div className="relative w-full flex items-center border dark:bg-white/10 rounded-lg">
      <Search size={16} className="absolute left-3 dark:text-white/20" />
      <Input
        type="search"
        placeholder="Search page"
        className="w-full h-7 text-sm dark:bg-transparent pl-10 pr-10 dark:placeholder:text-white/20 focus:outline-none border-none"
      />
    </div>
  );
}
